'use client'

import { useSigmaSurface } from '@/components/SigmaSurfaceProvider'

/** Injects keyframes once per document (embedded / light surfaces). */
let shimmerInjected = false

function injectShimmerStyle(): void {
  if (shimmerInjected || typeof document === 'undefined') return
  if (document.getElementById('sigma-skeleton-shimmer-embedded')) {
    shimmerInjected = true
    return
  }
  shimmerInjected = true
  const style = document.createElement('style')
  style.id = 'sigma-skeleton-shimmer-embedded'
  style.textContent = `
    @keyframes sigma-shimmer-embedded {
      0%   { background-position: 200% center; }
      100% { background-position: -200% center; }
    }
    .sigma-skeleton-bar {
      background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
      background-size: 200% 100%;
      animation: sigma-shimmer-embedded 1.6s ease-in-out infinite;
      border-radius: 6px;
    }
  `
  document.head.appendChild(style)
}

/**
 * Skeleton that mirrors MetricCard layout — layout-stable vs loaded cards.
 */
export function MetricCardSkeleton() {
  const isPortal = useSigmaSurface() === 'portal'
  if (!isPortal && typeof document !== 'undefined') injectShimmerStyle()

  const barClass = isPortal ? 'sigma-skeleton-shimmer' : 'sigma-skeleton-bar'

  return (
    <div
      style={{
        background: isPortal ? '#ffffff' : 'var(--sigma-surface, #ffffff)',
        border: isPortal ? '1px solid #e5e7eb' : '1px solid var(--sigma-border, #e5e7eb)',
        borderRadius: '12px',
        padding: '20px',
        minHeight: '132px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        minWidth: 0,
        width: '100%',
        maxWidth: '100%',
        boxShadow: isPortal ? 'var(--sigma-portal-shadow-card, none)' : undefined,
      }}
    >
      <div className={barClass} style={{ height: '14px', width: '60%', flexShrink: 0 }} />
      <div className={barClass} style={{ height: '28px', width: '75%', opacity: isPortal ? 1 : 0.9 }} />
      <div className={barClass} style={{ height: '13px', width: '85%', opacity: isPortal ? 1 : 0.75, flexShrink: 0 }} />
    </div>
  )
}
